import React from "react";
import { Star } from "lucide-react";

export default function Rating({ value = 0, count, size = 14, showCount = true }) {
    const full = Math.floor(value);
    const hasHalf = value - full >= 0.5;
    return (
        <div className="flex items-center gap-1" data-testid="rating-display">
            <div className="flex">
                {[0, 1, 2, 3, 4].map((i) => {
                    const filled = i < full || (i === full && hasHalf);
                    return (
                        <Star
                            key={i}
                            size={size}
                            strokeWidth={2}
                            className={filled ? "fill-brand-orange text-brand-orange" : "text-brand-line"}
                        />
                    );
                })}
            </div>
            {showCount && count != null && (
                <span className="text-xs font-bold text-brand-moss">({count})</span>
            )}
        </div>
    );
}
